// Google Analytics utility functions
// GA4 Measurement ID: G-5K12Z3XC8E
const GA_MEASUREMENT_ID = 'G-5K12Z3XC8E';

export const trackEvent = (eventName, eventParams = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

export const trackPageView = (path) => {
  if (window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
    });
  }
};

export const trackFormSubmission = (formName) => {
  trackEvent('form_submission', {
    form_name: formName,
  });
};

// GA4 recommended event for lead generation (strategy call form)
// Mark as conversion in GA4: Admin > Events > generate_lead > Mark as conversion
export const trackLeadGeneration = (formData = {}) => {
  trackEvent('generate_lead', {
    currency: 'USD',
    value: 100, // Estimated lead value for reporting
    ...formData,
  });
};

// GA4 recommended event for newsletter signups
// Mark as conversion in GA4: Admin > Events > sign_up > Mark as conversion
export const trackSignUp = (method = 'newsletter') => {
  trackEvent('sign_up', {
    method: method,
  });
};

export const trackButtonClick = (buttonName) => {
  trackEvent('button_click', {
    button_name: buttonName,
  });
};

export const trackScrollToSection = (sectionName) => {
  trackEvent('scroll_to_section', {
    section_name: sectionName,
  });
};
